// === Bootstrap Modal
import "bootstrap";

// === POLYFILLS
require('./polyfills/nodelist-foreach')

// === PLUGINS
require('lightgallery')
require('@nematis/uncode-fixes')
require('@nematis/cf7-effect')

// === COMPONENTS
require('./components/booking-sticky-button')
require('./components/datepicker')
require('./components/leaflet-map')
require('./components/lightbox')

// === CORE
require('./core/eventGa')
require('./core/header')
